import { UserDto } from '../../models';

export interface AuthState {
  user: UserDto | null;
  loading: boolean;
  error: string | null;
  isAuthenticated: boolean;
  currentTenantId: string | null;
}

export const initialState: AuthState = {
  user: null,
  loading: false,
  error: null,
  isAuthenticated: false,
  currentTenantId: null,
};
